import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "phoneNumber",
    "address",
    "neighborhood",
    "complement",
    "city",
    "textarea",
    "previewContainer"
  ];

  connect() {
    this.updatePreview();
  }

  updatePreview() {
    const dentist_name = "NOME DO DENTISTA";
    const patient_name = "NOME DO PACIENTE";
    const when = "amanhã às 9:00";
    const phone_number = this.phoneNumberTarget.value;
    const address = [this.addressTarget.value, this.complementTarget.value]
      .filter(el => {
        return el != "";
      })
      .join(", ");
    const full_address = `${address}, ${this.neighborhoodTarget.value}, ${
      this.cityTarget.value
    }`;

    this.previewContainerTarget.innerHTML = this.textareaTarget.value
      .replace(new RegExp("%nome_dentista%", "g"), dentist_name)
      .replace(new RegExp("%nome_paciente%", "g"), patient_name)
      .replace(new RegExp("%quando%", "g"), when)
      .replace(new RegExp("%telefone_clinica%", "g"), phone_number)
      .replace(new RegExp("%endereço_clinica%", "g"), full_address);
  }
}
